<div class="page-content-block">
  <ng-content />
</div>
